export default "__VITE_ASSET__CKN_XSCE__"